import comp from "./SearchBarContainer";
export default comp;
